import { Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {defaultIfEmpty} from 'rxjs/operators';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { EventBusService } from '@signature-it/ngx-generic/services';
import { EventData, EventName } from '@signature-it/ngx-generic/classes';

@Injectable({
    providedIn: 'root'
})
export class GTMResolver implements Resolve<Observable<any>> {
    constructor(protected eventBusService: EventBusService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
        if (GenericConfig.GTM_ID) {
            this.eventBusService.emit(new EventData(EventName.DATA_FOR_ANALYTICS_READY, {page: state.url, data: {}}));
        }
        return of().pipe(defaultIfEmpty(false));
    }
}
